import React from 'react'
import { Col } from 'reactstrap'

export default function SelectInstruction ({children}) {
  return (
    <Col xs='12' className='instructions'>
      <p>
        {children}
      </p>
    </Col>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/Licenses/SelectInstructions.js